import React from 'react'
import gsap from "gsap";
import { useRef } from "react";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import './contactUs.css'

gsap.registerPlugin(useGSAP);
gsap.registerPlugin(ScrollTrigger);

const ContactUs = (props) => {
    // console.log('props', props)
    const two = useRef(null);
    const ourValues = useRef(null);

    useGSAP(() => {
        const pTags = two.current.querySelectorAll("p");
        gsap.from(pTags, {
            scale: 1.2,
            opacity: 0,
            stagger: 1,
            duration: 1.9,
            ease: "elastic.out",
        });
    });

    // useGSAP(() => {
    //     gsap.from(ourValues.current, {
    //         opacity: 0,
    //         stagger: 0.1,
    //         delay: 0.2,
    //         duration: 10,
    //         ease: "elastic.out",
    //     });
    // });

    return (
        <div>
            <div className="container ourValuesContainer">
                <div className="section">
                    <div ref={two}>
                        <p className='contactUsText'>Contact us</p>
                        {/* <h1 ref={ourValues} className='ourValues'>Contact us</h1> */}
                        {/* <p>soon...</p> */}
                    </div>
                </div>
                <div className="contact-container">
                    <form className="contact-form">
                        <input type="text" placeholder="You name" />
                        <input type="email" placeholder="Email" />
                        <textarea placeholder="Write your message"></textarea>
                        <button type="submit" className="send-btn">Send Message</button>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default ContactUs